import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

// Renders a smooth area chart on a <div> using ApexCharts — the actual
// charting library Skote's own dashboard uses (its package.json pins
// "apexcharts": "^3.54.0", matched here), not Chart.js. Usage:
//   data-controller="revenue-chart"
//   data-revenue-chart-labels-value='["1 août","2 août",...]'
//   data-revenue-chart-values-value='[12000, 45000, ...]'
// Renders into the element itself (a <div>, not a <canvas> — ApexCharts
// builds its own SVG inside the target it's given).
export default class extends Controller {
  static values = { labels: Array, values: Array }

  connect() {
    this.chart = new ApexCharts(this.element, {
      chart: {
        type: "area",
        height: 260,
        toolbar: { show: false },
        zoom: { enabled: false }
      },
      series: [{ name: "CA", data: this.valuesValue }],
      xaxis: { categories: this.labelsValue, axisBorder: { show: false } },
      yaxis: { labels: { formatter: (v) => new Intl.NumberFormat("fr-FR").format(v) } },
      dataLabels: { enabled: false },
      stroke: { curve: "smooth", width: 2.5 },
      colors: ["#556ee6"], // Skote $primary
      fill: {
        type: "gradient",
        gradient: { shadeIntensity: 1, opacityFrom: 0.35, opacityTo: 0.05, stops: [0, 90, 100] }
      },
      grid: { borderColor: "#f1f1f1" },
      tooltip: { y: { formatter: (v) => `${new Intl.NumberFormat("fr-FR").format(v)} XOF` } }
    })
    this.chart.render()
  }

  disconnect() {
    this.chart?.destroy()
  }
}
